import bceceEngineeringSeatMatrix from '../data/bcece-engineering/BCECE_Engineering_SeatMatrix_2026.json';
import dceceCombinedPmpmmSeatMatrix from '../data/dcece-paramedical/DCECE_Combined_PMPMM_SeatMatrix_2025.json';
import dcecePolytechnicSeatMatrix from '../data/dcece-polytechnic/DCECE_Polytechnic_SeatMatrix_2025.json';
import ugmacAyushSeatMatrix from '../data/ugmac-ayush/UGMAC_AYUSH_SeatMatrix_2025.json';

const normalizeText = (value = '') => String(value).replace(/\s+/g, ' ').trim();
const compactText = (value = '') => normalizeText(value).toLowerCase().replace(/[^a-z0-9]+/g, '');

const GOVERNMENT_ENGINEERING_COLLEGES = new Set([
  'bcebhagalpur',
  'bcebakhtiyarpur',
  'mitmuzaffarpur',
  'gcegaya',
  'dcedarbhanga',
  'mcemotihari',
  'lnjpittechnologychapra',
  'sitsitamarhi',
  'scesasaram',
  'kcekatihar',
  'purneacollegeofengg',
  'rrsdcebegusarai',
  'bpmcemadhepura',
  'shriphanishwarnathrenuenggcollegeararia',
  'govtenggcollegebhojpur',
  'govtenggcollegearwal',
  'govtenggcollegeaurangabad',
  'govtenggcollegebanka',
  'govtenggcollegebuxar',
  'govtenggcollegegopalganj',
  'govtenggcollegejamui',
  'govtenggcollegejehanabad',
  'govtenggcollegekaimur',
  'govtenggcollegekhagaria',
  'govtenggcollegemadhubani',
  'govtenggcollegenawada',
  'govtenggcollegemunger',
  'govtenggcollegesheikhpura',
  'govtenggcollegesheohar',
  'govtenggcollegesiwan',
  'govtenggcollegeofsamastipur',
  'govtenggcollegevaishali',
  'govtenggcollegewchamparan',
  'govtenggcollegeoflakhisarai',
  'govtenggcollegekishanganj',
  'nalandacollegeofenggchandi',
  'supaulenggcollegesupaul',
  'saharsacollegeofengg',
  'collegeofagriculturalengineeringarabhojpur',
]);

const GOVERNMENT_POLYTECHNIC_COLLEGES = new Set([
  'bknsgpgopalganj',
  'bkpinstsitamarhi',
  'gpararia',
  'gparwal',
  'gpaurangabad',
  'gpbanka',
  'gpbarh',
  'gpbhojpur',
  'gpbuxar',
  'gpjamui',
  'gpjehanabad',
  'gpkaimur',
  'gpkhagaria',
  'gpkishanganj',
  'gpmadhepura',
  'gpmunger',
  'gpnawada',
  'gpsheikhpura',
  'gpsitamarhi',
  'gpsiwan',
  'gpsupaul',
  'gptekarigaya',
  'gpwestchamparan',
  'gpasthawannalanda',
  'gpbaraunibegusarai',
  'gpbhagalpur',
  'gpchapramarhowrahsaran',
  'gpdarbhanga',
  'gpdehrionsone',
  'gpgaya',
  'gpgopalganj',
  'gpkatihar',
  'gplakhisarai',
  'gpmadhubani',
  'gpmotihari',
  'gpmuzaffarpur',
  'gppatna7',
  'gppurnea',
  'gpsaharsa',
  'gpsheohar',
  'gptextiletechnathnagarbhagalpur',
  'gpvaishali',
  'gwpmuzaffarpur',
  'gwppatna14',
  'knsgpsamastipur',
]);

const PARAMEDICAL_PRIVATE_KEYWORDS = [
  'aayushman', 'akash', 'ambbedkar', 'ambedkar', 'anju', 'bhavya', 'budha', 'patliputra',
  'prameela', 'patna institute', 'patel', 'd.p. singh', 'dp singh', 'daksh', 'darbhanga nursing',
  'dhanarua', 'nesar', 'g.m.', 'gm', 'gautam', 'himalaya', 'himalya', 'hirawati', 'khawaja',
  'kingway', 'mgm', 'mundeshwari', 'manorama', 'bhagwati', 'maharishi', 'sushila', 'kanti',
  'mona', 'mother teresa', 'naina', 'nalanda nursing', 'national', 'om sai', 'paras',
  'parmarth', 'prameela', 'rb memorial', 'r.b. memorial', 'rp singh', 'r.p. singh', 'rup bala', 'rupbala',
  'sanjeevani', 'saroj', 'sarvoday', 'sadhu sharan', 'shershah', 'shri bhagwat', 'shyam lal',
  'subhwanti', 'swami', 'vidya', 'yamuna', 'raj kumari', 'srt memorial', 's.r.t. memorial',
  'yogendra', 'doon', 'shivam', 'krishna', 'saran nursing', 'aihe', 'deen dayal', 'b.s. institute',
  'bs institute', 'raj aryan', 'modern', 'nutan', 'benipur nursing', 'shyam school', 'nazma',
  'mahavir', 'sns institute', 's.n.s. institute', 'rrp school', 'r.r.p. school', 'rrp', 'vaidhnath',
  'nazirul', 'chandargupt', 'k.r.', 'kr', 'shakuntala', 'gyanjyoti', 'dps', 'd.p.s.', 'mitra',
  'dhano devi', 'sheikhpura institute', 'guidance', 'balajee', 'savitri', 'r.g. college',
  'rg college', 'trivaini', 'triveni', 'rs institute', 'r.s. institute', 'kk institute',
  'k.k. institute', 'nawada college', 'rajgir anm', 'mirganj', 'rb chandra', 'r.b. chandra',
  'ramakanti', 'vivekanand', 'magadh', 'aryabhat', 'pinak', 'bala jee', 'anushka', 'raj anm',
  'sa institute', 's.a. institute', 'satyandaram', 'jagdamba', 'madhubani institute', 'maitre',
  'subhadra', 'bhagalpur institute', 'kalami', 'katihar anm', 'gagdish', 'sk global', 's.k. global',
  'nwabang', 'navrang', 'ledar', 'leedar', 'skm nursing', 's.k.m. nursing', 'shree raj',
  'tripolia', 'gems', 'kameswar', 'kameswhar', 'raghunandan', 'simanchal', 'kailash', 'yashoda',
  'priyadarshani', 'ram sharan', 'ramsharan', 'raj kishor', 'rajkishor', 'trisha', 'humanity',
  'lav kush', 'lavkush', 'chanakya', 'kamleswari', 'hemwanti', 'skm college', 's.k.m. college',
  'narayan', 'vimla', 'jiya', 'kedarnath', 'dt institute', 'd.t. institute', 'global',
  'vaidehi', 'manav', 'ashoka', 'gulab', 'moty', 'moti babu', 'motibabu', 'children',
  'aaryamn', 'aaryaman', 'narmada', 'gurudev', 'life line', 'lifeline', 'ma savitri', 'royal',
  'universal', 'hira singh', 'ramdhari', 'gangotri', 'lt nursing', 'l.t. nursing', 'radiant',
  'vishundev', 'dev vally', 'dev valley', 'manorma', 'ss college', 's.s. college', 'm. kumar',
  'm kumar', 'sharda', 'rbsrdr', 'r.b.s.r.d.r.', 'stephene', 'gyatri', 'gayatri', 'rampratap',
  'sudarshan', 'applo', 'apolo', 'apollo', 'binda', 'pratik', 'tara chandi', 'tarachandi',
  'ahs building', 'panasiya', 'pnasiya', 'arjun', 'jandaha', 'mamta', 'lrd budha', 'lard budha',
  'lord budha', 'lord buddha', 'anamika', 'netaji', 'exalt', 'sityog', 'kinesis', 'rungta',
  'm.r. institute', 'mr institute', 'k.r. nursing', 'kr nursing', 'aryabhatt', 'j.p.i.t.', 'jpit',
  'm.r. college', 'mr college', 'applo nursing', 'appolo nursing'
];

const PARAMEDICAL_PRIVATE_PATTERNS = PARAMEDICAL_PRIVATE_KEYWORDS.map(keyword => {
  const escaped = keyword.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  return new RegExp(`\\b${escaped}\\b`, 'i');
});

const getInferredInstituteType = (moduleKey, institution = '', explicitType = '') => {
  const normalizedExplicit = normalizeText(explicitType);
  if (normalizedExplicit) {
    return normalizedExplicit;
  }

  const label = normalizeText(institution).toLowerCase();
  if (!label) {
    return '';
  }

  const hasAny = (patterns) => patterns.some((pattern) => pattern.test(label));

  if (moduleKey === 'paramedical') {
    // Explicitly check for government institutions or address snippets to prevent false positives
    if (
      /\b(civil surgeon|pmi|pmch|dmch|nmch|skmch|anmmch|jlnmch|jlnmc|bmims|pdc|phi|gpi|govt|government)\b/i.test(label) ||
      /\bg\.?m\.?c\.?\b/i.test(label)
    ) {
      if (
        label.startsWith('pmi') ||
        label.includes('under civil surgeon') ||
        label.includes('pmch') ||
        label.includes('nmch') ||
        label.includes('dmch') ||
        label.includes('gmc') ||
        /\bg\.?m\.?c\.?\b/i.test(label)
      ) {
        return 'Government';
      }
    }

    // GNM/ANM Government Schools & Training Schools
    const isGovtNurs = /\b(anm school|anm training|gnm training|gnm school|g\.n\.m\.\s+school|g\.n\.m\.\s+training|g\.n\.m\.\s+institute)\b/i.test(label);
    if (isGovtNurs) {
      const hasPrivKeyword = PARAMEDICAL_PRIVATE_PATTERNS.some((pattern) => pattern.test(label));
      return hasPrivKeyword ? 'Private' : 'Government';
    }

    // General private markers
    if (/\b(nursing|paramedical|academy|institute|higher studies|college of|education|foundation|association|trust|private)\b/i.test(label)) {
      return 'Private';
    }

    const isPriv = PARAMEDICAL_PRIVATE_PATTERNS.some((pattern) => pattern.test(label));
    return isPriv ? 'Private' : 'Government';
  }

  if (moduleKey === 'polytechnic') {
    const key = compactText(institution);
    return GOVERNMENT_POLYTECHNIC_COLLEGES.has(key) ? 'Government' : 'Private';
  }

  if (moduleKey === 'bceceEngineering') {
    const key = compactText(institution);
    return GOVERNMENT_ENGINEERING_COLLEGES.has(key) ? 'Government' : 'Private';
  }

  return '';
};

const GENERAL_CATEGORY_ORDER = ['All', 'UR', 'EWS', 'BC', 'EBC', 'SC', 'ST', 'RCG', 'DQ', 'SMQ', 'NRI'];
const FEMALE_CATEGORY_ORDER = ['All', 'UR', 'EWS', 'BC', 'EBC', 'SC', 'ST'];
const FEMALE_CATEGORY_MAP = {
  UR: 'FUR',
  EWS: 'FEWS',
  BC: 'FBC',
  EBC: 'FEBC',
  SC: 'FSC',
  ST: 'FST',
};

const normalizeCategoryCountMap = (counts = {}) =>
  Object.fromEntries(
    Object.entries(counts).map(([key, value]) => [normalizeText(key), Number(value ?? 0) || 0]),
  );

const normalizeCategorySeatRows = (rows = [], moduleKey = '') =>
  rows.map((row) => ({
    institution: normalizeText(row.institution),
    course: normalizeText(row.course),
    instituteType: getInferredInstituteType(moduleKey, row.institution, row.instituteType),
    seatScheme: normalizeText(row.seatScheme || 'State Quota'),
    counts: normalizeCategoryCountMap(row.counts),
    totalSeats: Number(row.totalSeats ?? row.counts?.Total ?? 0) || 0,
    isSampleData: Boolean(row.isSampleData),
  }));

const normalizeAyushRows = (rows = [], moduleKey = '') =>
  rows.map((row) => ({
    institution: normalizeText(row.institution),
    course: normalizeText(row.course),
    instituteType: getInferredInstituteType(moduleKey, row.institution, row.instituteType || row.collegeType),
    stateQuotaSeats: Number(row.stateQuotaSeats ?? 0) || 0,
    aiqSeats: Number(row.aiqSeats ?? 0) || 0,
    totalSeats: Number(row.totalSeats ?? 0) || 0,
  }));

const bceceRows = normalizeCategorySeatRows(bceceEngineeringSeatMatrix, 'bceceEngineering');
const paramedicalRows = normalizeCategorySeatRows(dceceCombinedPmpmmSeatMatrix, 'paramedical');
const polytechnicRows = normalizeCategorySeatRows(dcecePolytechnicSeatMatrix, 'polytechnic');
const ugmacAyushRows = normalizeAyushRows(ugmacAyushSeatMatrix, 'ugmacAyush');

export const examSeatMatrixModules = {
  bceceEngineering: {
    key: 'bceceEngineering',
    title: 'BCECE Engineering',
    mode: 'category',
    supportsFemaleSeatType: true,
    data: bceceRows,
  },
  paramedical: {
    key: 'paramedical',
    title: 'Bihar Paramedical (DCECE PM / PMM)',
    mode: 'category',
    supportsFemaleSeatType: false,
    data: paramedicalRows,
    note: 'Combined PM / PMM seat matrix is shown here because the uploaded source is shared across both levels.',
  },
  polytechnic: {
    key: 'polytechnic',
    title: 'Bihar Polytechnic (DCECE PE)',
    mode: 'category',
    supportsFemaleSeatType: false,
    data: polytechnicRows,
    note: 'The uploaded Polytechnic workbook is now connected. Government institutes show category-wise breakup, while private institutes currently show total approved seats from the source.',
  },
  ugmacAyush: {
    key: 'ugmacAyush',
    title: 'Bihar Medical (UGMAC Ayush)',
    mode: 'quota',
    data: ugmacAyushRows,
    note: 'The uploaded AYUSH seat matrix includes state quota, AIQ, and total seats. Category-wise breakup is not available in this source yet.',
  },
};

export const getExamSeatMatrixModule = (moduleKey) => examSeatMatrixModules[moduleKey] ?? null;

export const getExamSeatMatrixInstitutionOptions = (moduleKey) => {
  const module = getExamSeatMatrixModule(moduleKey);
  if (!module) return [];
  return [...new Set(module.data.map((row) => row.institution))].sort((a, b) => a.localeCompare(b));
};

export const getExamSeatMatrixCourseOptions = (moduleKey) => {
  const module = getExamSeatMatrixModule(moduleKey);
  if (!module) return [];
  return [...new Set(module.data.map((row) => row.course))].sort((a, b) => a.localeCompare(b));
};

export const getExamSeatMatrixInstituteTypeOptions = (moduleKey) => {
  const module = getExamSeatMatrixModule(moduleKey);
  if (!module) return [];
  return [...new Set(module.data.map((row) => row.instituteType).filter(Boolean))].sort((a, b) =>
    a.localeCompare(b),
  );
};

export const getExamSeatMatrixSeatTypeOptions = (moduleKey) => {
  const module = getExamSeatMatrixModule(moduleKey);
  if (!module || module.mode !== 'category') return [];
  return module.supportsFemaleSeatType ? ['General', 'Female'] : ['General'];
};

export const getExamSeatMatrixCategoryOptions = (moduleKey, seatType = 'General') => {
  const module = getExamSeatMatrixModule(moduleKey);
  if (!module || module.mode !== 'category') return ['All'];

  const availableKeys = new Set();
  module.data.forEach((row) => {
    Object.keys(row.counts || {}).forEach((key) => availableKeys.add(key));
  });

  const order = seatType === 'Female' ? FEMALE_CATEGORY_ORDER : GENERAL_CATEGORY_ORDER;
  return order.filter((category) => {
    if (category === 'All') return true;
    if (seatType === 'Female') {
      return availableKeys.has(FEMALE_CATEGORY_MAP[category] || '');
    }
    return availableKeys.has(category);
  });
};

const getVisibleSeatCount = (module, row, seatType = 'General', category = 'All') => {
  if (!module) return 0;

  if (module.mode === 'quota') {
    return row.stateQuotaSeats ?? 0;
  }

  const counts = row.counts || {};
  if (category === 'All') {
    const categoryCountKeys = Object.keys(counts).filter((key) => key !== 'Total' && !key.startsWith('F'));
    if (categoryCountKeys.length === 0) {
      return row.totalSeats ?? 0;
    }
    if (seatType === 'Female' && module.supportsFemaleSeatType) {
      return Object.values(FEMALE_CATEGORY_MAP).reduce((sum, key) => sum + (counts[key] ?? 0), 0);
    }
    return Object.entries(counts)
      .filter(([key]) => key !== 'Total' && !key.startsWith('F'))
      .reduce((sum, [, value]) => sum + (value ?? 0), 0);
  }

  if (seatType === 'Female' && module.supportsFemaleSeatType) {
    return counts[FEMALE_CATEGORY_MAP[category] || ''] ?? 0;
  }

  return counts[category] ?? 0;
};

export const filterExamSeatMatrixRows = (
  moduleKey,
  {
    instituteType = 'All',
    institution = 'All',
    course = 'All',
    seatType = 'General',
    category = 'All',
  } = {},
) => {
  const module = getExamSeatMatrixModule(moduleKey);
  if (!module) return [];

  return module.data
    .filter((row) => instituteType === 'All' || row.instituteType === instituteType)
    .filter((row) => institution === 'All' || row.institution === institution)
    .filter((row) => course === 'All' || row.course === course)
    .map((row) => ({
      ...row,
      visibleSeats: getVisibleSeatCount(module, row, seatType, category),
    }))
    .filter((row) => module.mode === 'quota' || category === 'All' || row.visibleSeats > 0)
    .sort(
      (first, second) =>
        first.institution.localeCompare(second.institution) ||
        first.course.localeCompare(second.course),
    );
};
